export default __webpack_public_path__ + "static/media/20220206_152352.8bd13bef.png";